import { PlanType } from '~/types/subscriptionTypes';

export default function getSubscriptionServices(plan: PlanType) {
  const planService = plan?.subscription_plan_services;
  const packageService =
    plan.subscription_plan_package.length > 0
      ? plan.subscription_plan_package[0].package.package_services
      : [];
  const totalServices = [...packageService, ...planService];
  return totalServices;
}
